function getCookie(name) {
    let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, days) {
    let maxAge = days * 24 * 60 * 60;
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}`;
}

export function handleCookieBanner() {
    const banner = document.getElementById("cookie-banner");
    const acceptButton = document.getElementById("accept-cookies");

    if (!banner || !acceptButton) return;

    banner.style.display = "flex";

    if (getCookie("cookiesAccepted")) {
        banner.style.display = "none";
        return;
    }

    acceptButton.addEventListener("click", () => {
        setCookie("cookiesAccepted", "true", 365);
        banner.style.display = "none";
    });
}
